export const VerificationChannel = {
    Email: {
        label: "Email",
        value: "email",
    },
    Phone: {
        label: "Phone",
        value: "phone",
    },
};

export const VerificationChannelsArray = [
    VerificationChannel.Email,
    VerificationChannel.Phone,
];